import './style.css'
import App from './Globe/App';

new App();